import { getRequest, patchRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";
import { CompleteAmbassadorProfileDTO } from "utils/helpers/models/ambassador/complete-profile.dto";
import { EditProfileAmbassador } from "utils/helpers/models/ambassador/edit-profile.dto";

export const AMBASSADOR_APIS = {
    updateAmbassadorProfile: (body: CompleteAmbassadorProfileDTO) => patchRequest('ambassador/ambassador-profile', body),
    updateUserProfile: (body: CompleteAmbassadorProfileDTO) => patchRequest('ambassador/user-profile', body),
    uploadFile: (body: FormData) => postRequest("/file/upload", body),
    uploadMultipleFiles: (body: FormData) => postRequest("/file/upload-multiple", body),
    updateProfile: (body: EditProfileAmbassador) => patchRequest('/ambassador/user-profile', body),
    getAdminAmbassadorEvents: (params: any) => getRequest('/admin-events', params),
    joinAmbassadorEvent: (id: number, body:any) => postRequest(`/admin-events/${id}/subscribe`, body),

    getNearestSlot: () => getRequest('/ambassador/nearest-available-slots'),
    postTeamBookSession: (ambassadorId: number,body: any) => postRequest(`/team/book-session?ambassadorId=${ambassadorId}`, body),
    getAmbassadorProducts: () => getRequest('/ambassador/products'),
    getAmbassadorBadges: (body :any) => getRequest('/users/my/awarded/badges',body), 
    updateAmbassadorTier: (body :any) => patchRequest('/ambassador/update-tier',body), 
    getEarnedPoints: (params: any) => getRequest('/ambassador/activities/points-earned', params),
    getUsedPoints: (params: any) => getRequest('/ambassador/product-requests', params),
    postProductRequest : (body :any) => postRequest('/ambassador/add-ambassador-product-request',body),
    getActivity : (body :any) => getRequest('/ambassador/activities',body),
    getPromotions : (body :any) => getRequest('/ambassador/activities/post-and-shares',body),
    postNewPost : (body :any) => postRequest('/ambassador/create-post',body),
    postCreateShare : (body :any) => postRequest('/ambassador/create-share',body),
    getEventFollowUp: (params?: any) => getRequest('/event/ambassador/events-for-followup', params),
    postEventFollowUp: (id: number,body: any) => postRequest(`/ambassador/request-follow-up/${id}`,body),
    getJoinAbleEvents: () => getRequest('/event/ambassador/joinable-events'),
    getEventDetails: (id: number) => getRequest(`/event/${id}/details`),
    postJoinMeeting : (id: number,body :any) => postRequest(`/ambassador/join-event/${id}`,body),
    postJoinEvents : (id:number,body:any) => postRequest(`/ambassador/join-event/${id}`,body),
    getUserProfile: () => getRequest('/user/profile'),
    getAmbassadorExperienceById: (id: number) => getRequest(`/admin-events/${id}`),
    getAmbassadorCommunityMessages: (id: number, params?: any) => getRequest(`/admin-events/${id}/messages`, params),
    postAmbassadorCommunityMessages: (id: number, body: any) => postRequest(`/admin-events/${id}/messages`, body),
    markAttendanceAmbassadorExperience : (id:number, body:any) => putRequest(`/admin-events/${id}/attendance/bulk`, body),
    toggleNotification: () => postRequest("/auth/notification-toggle", {}),
    getAmbassadorProfile: () => getRequest(`/user/profile`),






}